import { createSelector } from 'reselect';
import moment from 'moment';
import objectToArray from '../../../../common/utils/object-to-array';
import defaultEventImage from '../../../../common/assets/images/cardImageFallback.jpg';

const legislatureSortMap = {
  National: 1,
  State: 2,
  Unknown: 3,
};

const eventsStateSelector = ({ entities: { events } }) => events || {};

const buildDateString = ({ startDate, endDate }) => {
  const start = moment(startDate);
  const end = moment(endDate);
  if (start.isSame(end, 'day')) {
    // returns formated single date
    return start.format('MMMM Do, YYYY');
  }
  if (start.isSame(end, 'month')) {
    // returns formatted duration: January 1st-4th 2016
    return `${start.format('MMMM')} ${start.format('Do')} - ${end.format(
      'Do'
    )} ${start.format('YYYY')}`;
  }
  // fall back format: 01/01/2016-02/01/2016
  return `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`;
};

const addDisplayData = event => {
  const isRemote = ['teleforums', 'webinars'].some(remoteCat =>
    (event.category || '').toLowerCase().includes(remoteCat)
  );

  return {
    ...event,
    color:
      event.legislatureType && event.legislatureType.toLowerCase() === 'national' ? 'blue' : 'orange',
    displayDate: buildDateString(event),
    imageUrl: event.imageUrl || defaultEventImage,
    isRemote,
    legislatureTypeSort: legislatureSortMap[event.legislatureType],
  };
};

export const getDisplayEvents = createSelector(
  [eventsStateSelector],
  events => {
    return objectToArray(events).map(addDisplayData);
  }
);

export const getEvents = createSelector([eventsStateSelector], events => {
  return objectToArray(events);
});

export const getEvent = createSelector(
  [eventsStateSelector, (_, { id }) => id],
  (events, id) => {
    const event = (events || {})[id];
    return event ? addDisplayData(event) : event;
  }
);



// WEBPACK FOOTER //
// ./src/App/events/selectors/events/index.js